










































































































import { Component, Watch } from 'vue-property-decorator';
import WorkerWizardWorkType from '@/components/Workers/WorkerWizardWorkType.vue'
import WorkerWizardDetails from '@/components/Workers/WorkerWizardDetails.vue'
import WorkerWizardAddress from '@/components/Workers/WorkerWizardAddress.vue'
import WorkerWizardAttributes from '@/components/Workers/WorkerWizardAttributes.vue'
import WorkerWizardDuplicateCheck from '@/components/Workers/WorkerWizardDuplicateCheck.vue'
import WorkerWizardReview from '@/components/Workers/WorkerWizardReview.vue'
import WorkerWizardMergeReview from '@/components/Workers/WorkerWizardMergeReview.vue'
import WorkerWizardComplete from '@/components/Workers/WorkerWizardComplete.vue'
import Alert from '@/components/Shared/Alert.vue';
import {WorkerWizardModule} from '@/store/modules/workerWizard';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import BranchDto from '@/models/Branches/BranchDto';

@Component({
  name: 'WorkerWizard',
  components: { Alert, WorkerWizardWorkType, WorkerWizardDetails, WorkerWizardAddress, WorkerWizardAttributes, WorkerWizardDuplicateCheck, WorkerWizardReview, WorkerWizardMergeReview, WorkerWizardComplete }
})
export default class extends GiganautVue {

  showResetDialog = false;

	beforeMount() {
		AgencySettingsModule.getBranches();
  }

  get worker() {
    return WorkerWizardModule.newWorker;
  }

  @Watch('worker.defaultBranch')
  async onDefaultBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.worker.defaultDesk = null;
    }
  }

  get currentStep() {
    return WorkerWizardModule.newWorker.currentStep;
  }

  get nextButtonName() {
    if (this.currentStep === 6) {
      // Review step - button text depends on whether we're merging or creating
      return WorkerWizardModule.selectedDuplicateMatch ? 'Update' : 'Create';
    }
    return 'Next';
  }

  get step() {
    return this.currentStep;
  }

  set step(value) {
    if (this.currentStep != value) {
      WorkerWizardModule.newWorker.currentStep = value;
    }
  }

  get showBackButton() {
    return this.currentStep >= 2 && this.currentStep <= 6;
  }

  get showNextButton() {
    // Hide next button on Complete step
    return this.currentStep !== 7;
  }

  get isNextDisabled() {
    // Disable Next on Duplicate Check step if there's an email match but no selection
    if (this.currentStep === 5) {
      const hasEmailMatch = WorkerWizardModule.duplicateMatches.some(m => m.emailMatch);
      const hasSelection = !!WorkerWizardModule.selectedDuplicateMatch;
      return hasEmailMatch && !hasSelection;
    }
    return false;
  }

  get showResetButton() {
    return this.currentStep >= 1 && this.currentStep <= 6;
  }

  get loading() {
    return WorkerWizardModule.loading;
  }

  get isMergeMode() {
    return !!WorkerWizardModule.selectedDuplicateMatch;
  }

  async backClick() {
    // If going back from Duplicate Check step, reset the check state
    if (this.currentStep === 5) {
      const duplicateCheckRef = this.$refs.duplicateCheck as any;
      if (duplicateCheckRef && duplicateCheckRef.resetCheck) {
        duplicateCheckRef.resetCheck();
      }
    }
    this.step -= 1;
  }

  resetWizard() {
    this.showResetDialog = false;
    WorkerWizardModule.cleanState();
    this.step = 1;
  }

  async nextClick() {
    if (this.currentStep === 1) {
      // Validate work type selection and lock it
      if (await(this.$refs.workerWorkType as any).validateForm()) {
        return;
      }
      WorkerWizardModule.lockWorkType();
    }
    else if (this.currentStep === 2) {
      if (await(this.$refs.workerDetails as any).validateForm()) {
        return;
      }
    }
    else if (this.currentStep === 3) {
      if (await(this.$refs.workerAddress as any).validateForm()) {
        return;
      }
    }
    else if (this.currentStep === 4) {
      // Validate attributes (optional, so always passes)
      if (await(this.$refs.workerAttributes as any).validateForm()) {
        return;
      }
    }
    else if (this.currentStep === 5) {
      // Duplicate Check step - validate (requires selection if email match exists)
      if (await(this.$refs.duplicateCheck as any).validateForm()) {
        return;
      }
    }
    else if (this.currentStep === 6) {
      // Review step - merge or create depending on selection
      let success: boolean;
      if (WorkerWizardModule.selectedDuplicateMatch) {
        success = await WorkerWizardModule.mergeIntoExistingWorker();
      } else {
        success = await WorkerWizardModule.createNewWorker();
      }
      if (success) {
        this.step += 1;
      }
      return; // Don't fall through to step increment
    }
    this.step += 1;
  }
}
